import React, {useEffect, Component} from 'react';
import Lottie from "lottie-react";
import hilottieAnimation from "../assets/img/hi-lottie.json";

const Hilottie = () => {
  return <Lottie animationData={hilottieAnimation} />;
};

export default Hilottie;